(function() {
  var existing = window.DOP3FlavorLineup;

  if (existing && typeof existing.init === 'function') {
    existing.init(document);
    return;
  }

  var instances = new WeakMap();
  var mobileQuery = window.matchMedia('(max-width: 900px)');
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)');

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(scope) {
    var container = scope || document;
    var roots = [];

    if (container.matches && container.matches('[data-dop3-flavor-lineup]')) {
      roots.push(container);
    }

    roots = roots.concat(toArray(container.querySelectorAll('[data-dop3-flavor-lineup]')));

    roots.forEach(function(root) {
      if (!instances.has(root)) {
        instances.set(root, new DOP3FlavorLineup(root));
      }
    });
  }

  function destroy(scope) {
    var container = scope || document;
    var roots = [];

    if (container.matches && container.matches('[data-dop3-flavor-lineup]')) {
      roots.push(container);
    }

    roots = roots.concat(toArray(container.querySelectorAll('[data-dop3-flavor-lineup]')));

    roots.forEach(function(root) {
      var instance = instances.get(root);
      if (instance) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  function DOP3FlavorLineup(root) {
    this.root = root;
    this.itemsWrap = root.querySelector('[data-flavor-items]');
    this.stage = root.querySelector('[data-flavor-stage]');
    this.hoverArea = root.querySelector('.dop3-flavor-lineup__shell') || root;
    this.items = toArray(root.querySelectorAll('[data-flavor-item]'));
    this.backgrounds = toArray(root.querySelectorAll('[data-flavor-background]'));
    this.contentPanels = toArray(root.querySelectorAll('[data-flavor-content]'));
    this.dots = toArray(root.querySelectorAll('[data-flavor-dot]'));
    this.activeIndex = 0;
    this.editorLocked = false;
    this.listeners = [];
    this.scrollFrame = null;
    this.scrollEndTimer = null;
    this.resizeFrame = null;
    this.observer = null;

    if (!this.items.length) {
      return;
    }

    this.bind();
    this.activateFlavor(0, { scroll: false });
    this.setupMobileTracking();
  }

  DOP3FlavorLineup.prototype.addListener = function(element, eventName, handler, options) {
    if (!element) {
      return;
    }

    element.addEventListener(eventName, handler, options);
    this.listeners.push({
      element: element,
      eventName: eventName,
      handler: handler,
      options: options
    });
  };

  DOP3FlavorLineup.prototype.bind = function() {
    var self = this;

    this.items.forEach(function(item) {
      var index = parseInt(item.getAttribute('data-flavor-index'), 10);

      self.addListener(item, 'mouseenter', function() {
        if (hoverQuery.matches && !self.editorLocked) {
          self.activateFlavor(index, { scroll: false });
        }
      });

      self.addListener(item, 'focusin', function() {
        self.activateFlavor(index, { scroll: false });
      });

      self.addListener(item, 'click', function(event) {
        if (event.target.closest('a')) {
          if (self.editorLocked && window.Shopify && window.Shopify.designMode) {
            event.preventDefault();
          }
          return;
        }

        self.activateFlavor(index, { scroll: mobileQuery.matches });
      });
    });

    this.addListener(this.hoverArea, 'mouseleave', function() {
      if (hoverQuery.matches && !self.editorLocked) {
        self.activateFlavor(0, { scroll: false });
      }
    });

    this.dots.forEach(function(dot) {
      var index = parseInt(dot.getAttribute('data-flavor-index'), 10);

      self.addListener(dot, 'click', function() {
        self.activateFlavor(index, { scroll: true });
      });
    });

    this.addListener(this.itemsWrap, 'scroll', function() {
      if (!mobileQuery.matches) {
        return;
      }

      if (!self.scrollFrame) {
        self.scrollFrame = window.requestAnimationFrame(function() {
          self.scrollFrame = null;
          self.activateClosestSlide();
        });
      }

      if (self.scrollEndTimer) {
        window.clearTimeout(self.scrollEndTimer);
      }

      self.scrollEndTimer = window.setTimeout(function() {
        self.scrollEndTimer = null;
        self.centerClosestSlide();
      }, 140);
    }, { passive: true });

    this.addListener(window, 'resize', function() {
      if (!mobileQuery.matches || !self.items[self.activeIndex]) {
        return;
      }

      if (self.resizeFrame) {
        window.cancelAnimationFrame(self.resizeFrame);
      }

      self.resizeFrame = window.requestAnimationFrame(function() {
        self.resizeFrame = null;
        self.scrollToItem(self.items[self.activeIndex], 'auto');
      });
    }, { passive: true });

    var queryHandler = function() {
      self.setupMobileTracking();
      if (mobileQuery.matches) {
        self.activateClosestSlide();
      } else if (!self.editorLocked) {
        self.activateFlavor(self.activeIndex, { scroll: false });
      }
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', queryHandler);
      this.listeners.push({
        element: mobileQuery,
        eventName: 'change',
        handler: queryHandler,
        media: true
      });
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(queryHandler);
      this.listeners.push({
        element: mobileQuery,
        eventName: 'change',
        handler: queryHandler,
        legacyMedia: true
      });
    }
  };

  DOP3FlavorLineup.prototype.setupMobileTracking = function() {
    var self = this;

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (!mobileQuery.matches || this.items.length < 2) {
      return;
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function(entries) {
        var bestEntry = null;

        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            return;
          }

          if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
            bestEntry = entry;
          }
        });

        if (!bestEntry || bestEntry.intersectionRatio < 0.58) {
          return;
        }

        var index = parseInt(bestEntry.target.getAttribute('data-flavor-index'), 10);
        self.activateFlavor(index, { scroll: false });
      }, {
        root: this.itemsWrap,
        threshold: [0.55, 0.65, 0.75]
      });

      this.items.forEach(function(item) {
        self.observer.observe(item);
      });
    }
  };

  DOP3FlavorLineup.prototype.activateClosestSlide = function() {
    if (!this.itemsWrap || !this.items.length) {
      return;
    }

    var wrapRect = this.itemsWrap.getBoundingClientRect();
    var wrapCenter = wrapRect.left + (wrapRect.width / 2);
    var closestIndex = this.activeIndex;
    var closestDistance = Infinity;

    this.items.forEach(function(item) {
      var rect = item.getBoundingClientRect();
      var itemCenter = rect.left + (rect.width / 2);
      var distance = Math.abs(wrapCenter - itemCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = parseInt(item.getAttribute('data-flavor-index'), 10);
      }
    });

    this.activateFlavor(closestIndex, { scroll: false });
  };

  DOP3FlavorLineup.prototype.centerClosestSlide = function() {
    this.activateClosestSlide();
    this.scrollToItem(this.items[this.activeIndex]);
  };

  DOP3FlavorLineup.prototype.activateFlavor = function(index, options) {
    var settings = options || {};
    var item = this.items[index];

    if (!item) {
      return;
    }

    this.activeIndex = index;
    this.itemsWrap.classList.add('has-active');
    this.root.style.setProperty('--dop3-active-background', item.getAttribute('data-background-color') || '');
    this.root.style.setProperty('--dop3-active-text', item.getAttribute('data-text-color') || '');
    this.root.style.setProperty('--dop3-active-accent', item.getAttribute('data-accent-color') || '');

    this.items.forEach(function(flavorItem, itemIndex) {
      var isActive = itemIndex === index;
      flavorItem.classList.toggle('is-active', isActive);
      flavorItem.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    this.backgrounds.forEach(function(background, backgroundIndex) {
      background.classList.toggle('is-active', backgroundIndex === index);
    });

    this.contentPanels.forEach(function(panel, panelIndex) {
      var isActive = panelIndex === index;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.dots.forEach(function(dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    if (settings.scroll && mobileQuery.matches) {
      this.scrollToItem(item);
    }
  };

  DOP3FlavorLineup.prototype.scrollToItem = function(item, behavior) {
    if (!item || !this.itemsWrap) {
      return;
    }

    var wrapRect = this.itemsWrap.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var left = this.itemsWrap.scrollLeft + itemRect.left - wrapRect.left - ((wrapRect.width - itemRect.width) / 2);
    var maxLeft = Math.max(0, this.itemsWrap.scrollWidth - this.itemsWrap.clientWidth);

    left = Math.max(0, Math.min(left, maxLeft));

    if (Math.abs(this.itemsWrap.scrollLeft - left) < 1) {
      return;
    }

    this.itemsWrap.scrollTo({
      left: left,
      behavior: behavior || (prefersReducedMotion() ? 'auto' : 'smooth')
    });
  };

  DOP3FlavorLineup.prototype.selectBlock = function(blockId) {
    var item = this.items.filter(function(flavorItem) {
      return flavorItem.getAttribute('data-flavor-id') === blockId;
    })[0];

    if (!item) {
      return;
    }

    var index = parseInt(item.getAttribute('data-flavor-index'), 10);
    this.editorLocked = true;
    this.activateFlavor(index, { scroll: mobileQuery.matches });
  };

  DOP3FlavorLineup.prototype.deselectBlock = function() {
    this.editorLocked = false;
  };

  DOP3FlavorLineup.prototype.destroy = function() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.scrollFrame) {
      window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }

    if (this.scrollEndTimer) {
      window.clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = null;
    }

    if (this.resizeFrame) {
      window.cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = null;
    }

    this.listeners.forEach(function(listener) {
      if (listener.media && listener.element.removeEventListener) {
        listener.element.removeEventListener(listener.eventName, listener.handler);
      } else if (listener.legacyMedia && listener.element.removeListener) {
        listener.element.removeListener(listener.handler);
      } else {
        listener.element.removeEventListener(listener.eventName, listener.handler, listener.options);
      }
    });

    this.listeners = [];
  };

  window.DOP3FlavorLineup = {
    init: init,
    destroy: destroy
  };

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', function(event) {
    var root = document.querySelector('[data-section-id="' + event.detail.sectionId + '"][data-dop3-flavor-lineup]');
    var instance = root ? instances.get(root) : null;

    if (instance) {
      instance.selectBlock(event.detail.blockId);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var root = document.querySelector('[data-section-id="' + event.detail.sectionId + '"][data-dop3-flavor-lineup]');
    var instance = root ? instances.get(root) : null;

    if (instance) {
      instance.deselectBlock();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }
})();
